const countries = ["Canada", "Australia", "UK", "Other"];

export default countries;
